import { useRef } from "react";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";

import "leaflet/dist/leaflet.css";
import { markerIcon } from "utils/data";
import { Icon } from "leaflet";

export const MapSection = ({ mapCordiantes, markerList, ...props }) => {
  const mapRef = useRef(null);
  const markerImg = new Icon({
    iconUrl: markerIcon,
    iconSize: [35, 35],
  });
  return (
    <MapContainer
      center={mapCordiantes}
      zoom={13}
      ref={mapRef}
      className="border border-2 border-secondary rounded-4 w-100 h-100"
      style={{
        minHeight: "400px",
        maxHeight: "700px",
      }}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {markerList?.map((marker, index) => (
        <Marker
          position={[marker.latitude, marker.longitude]}
          key={index}
          icon={markerImg}
          title={marker.name}
        >
          <Popup>
            {marker.name} <br /> {marker.fulladdress}
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};
